// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddCartTooltipMypage_wrapper__aC_Dg","hide":"AddCartTooltipMypage_hide__vYK55","title":"AddCartTooltipMypage_title__0kSpl","button":"AddCartTooltipMypage_button__DLSdL"};